import React from 'react'
import Link from 'gatsby-link'

const AboutPage = () => (
    <div className="container">

        <div className="row">
            <div className="col-lg-7 col-md-4 col-sm-4 about">

                <p className="bigger">Hi,</p>
                <p className="bigger">My name is Sandra Harrison and I am an Anthropologist offering 7 years' qualitative research experience.</p>
                <p className="bigger">Anthropology as a human science empowers me to understand subjective experience, gain insights into people’s motivations and actions, and cutting through the clutter of taken 'for' granted assumptions and conventional wisdom.</p>
                <p className="bigger">I want to apply my anthropological analytical skills and ethnographic methods to find out what it means to be human in today's world and translate these findings into a positive service design experience.</p>
                <br />

                <h4>Anthropology has taught me how to:</h4>
                <ul className="bigger">
                    <li>make use of my natural curiosity and pay close attention</li>
                    <li>ask the right questions</li>
                    <li>develop a reading to understand human behaviour, motivations, attitudes and frustrations</li>
                    <li>recognise and uncover patterns of cultural practice</li>
                    <li>be empathic and cultural aware for the research subjects and environment</li>
                    <li>make sense of my observations and communicate my moments of clarity in a structured way</li>
                </ul>
                <br />
                <br />
                <br />
                <br />
            </div>
            <div className="col-lg-5 col-md-8 col-sm-8 about">

                <h4>My research expertise includes:</h4>
                <ul className="tags">
                    <li>The postal industry</li>
                    <li>Prosthetic technology</li>
                    <li>Body politics</li>
                    <li>Travel phenomena</li>
                    <li>Age-friendly communities and social media</li>
                    <li>Family and home movies</li>
                </ul>

                <h4>My methods include:</h4>
                <ul className="tags">
                    <li>Sensemaking and Abductive Reasoning</li>
                    <li>Narratives and Storytelling Analysis</li>
                    <li>Participative Observation</li>
                    <li>Qualitative Interview</li>
                    <li>Ethnographic Listening</li>
                    <li>One-on-One User Testing</li>
                    <li>Remote Testing</li>
                    <li>Guerrilla Prototype Testing</li>
                    <li>Card Sorting</li>
                    <li>Treejack Testing</li>
                    <li>Diary Study Research</li>
                    <li>Survey</li>
                    <li>Heuristic Evaluation</li>
                    <li>Literature Review</li>
                    <li>Competitive Analysis</li>
                    <li>Co-Design Workshop</li>
                    <li>Success Criteria Workshop</li>
                    <li>Qualitative phenomenology analysis</li>
                    <li>Thick Description</li>
                    <li>Narratives and Storytelling</li>
                    <li>Research Diary</li>
                    <li>Cultural probe: Iconographical-Iconological Image-Discourse Analysis</li>
                </ul>

                <br />
                <br />
                <br />
                <br />
            </div>
        </div>
    </div>
)

export default AboutPage



// WEBPACK FOOTER //
// ./src/pages/about.js